module.exports = __webpack_public_path__ + "img/empresa-bayer-sede.28268ce9.jpg";